module.exports = __webpack_public_path__ + "fonts/93778eb.ttf";